/**
 * Umschalter für den Grundton: hell, dunkel oder Systemeinstellung.
 *
 * Als Radiogruppe umgesetzt, nicht als durchklickbarer Knopf: Bei drei
 * Möglichkeiten muss sichtbar sein, welche gilt — und „System" ist keine
 * Zwischenstufe zwischen hell und dunkel, sondern eine eigene Wahl.
 */
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme, type Theme } from '@/hooks/useTheme';

const MOEGLICHKEITEN: Array<{ wert: Theme; label: string; icon: typeof Sun }> = [
  { wert: 'light', label: 'Hell', icon: Sun },
  { wert: 'dark', label: 'Dunkel', icon: Moon },
  { wert: 'system', label: 'System', icon: Monitor },
];

export interface ThemeToggleProps {
  className?: string;
}

export function ThemeToggle({ className = '' }: ThemeToggleProps) {
  const { theme, setTheme } = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label="Darstellung"
      className={`inline-flex items-center gap-0.5 rounded-full bg-surface-200 p-0.5 ${className}`.trim()}
    >
      {MOEGLICHKEITEN.map(({ wert, label, icon: Icon }) => {
        const aktiv = theme === wert;
        return (
          <button
            key={wert}
            type="button"
            role="radio"
            aria-checked={aktiv}
            aria-label={label}
            title={label}
            onClick={() => setTheme(wert)}
            className={[
              'flex items-center justify-center rounded-full p-1.5 transition-colors',
              aktiv
                ? 'bg-surface-100 text-surface-900 shadow-sm'
                : 'text-surface-500 hover:text-surface-700',
            ].join(' ')}
          >
            <Icon className="h-4 w-4" aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
}

export default ThemeToggle;
